import { RESET_APP } from 'actions/types'
import { combineReducers } from 'redux'
import app from './app'
import fundraiser from './fundraiser'
import products from './products'

const appReducer = combineReducers({
  app,
  fundraiser,
  products,
})

export default (state, action) => {
  if (action.type === RESET_APP) {
    state = undefined
  }
  return appReducer(state, action)
}
